import React from 'react';
import { Stack, Text } from '@chakra-ui/react';
import Wrapper from '@components/atoms/Wrapper';
import Button from '@components/atoms/Button';

const Example = ({ data: { title, text } = { title: ``, text: `` } }) => {
  return (
    <Wrapper narrow>
      <Text as="h2">Buttons Example:</Text>
      <Text as="h2">{title}</Text>
      <Text>{text}</Text>
      <Stack>
        <Text as="p">Purple:</Text>
        <Button isActive={false}>Purple</Button>
        <Button isActive>Purple Active</Button>
        <Button isDisabled>Purple Disabled</Button>
        <Text as="p">Ghost:</Text>
        <Button variant="ghost" isActive={false}>
          Ghost
        </Button>
        <Button variant="ghost" isActive>
          Ghost Active
        </Button>
        <Button variant="ghost" isDisabled>
          Ghost Disabled
        </Button>
        <Text as="p">Link:</Text>
        <Button variant="link" isActive={false}>
          Link
        </Button>
        <Button variant="link" isActive>
          Link Active
        </Button>
        <Button variant="link" isDisabled>
          Link Disabled
        </Button>
      </Stack>
    </Wrapper>
  );
};

export default Example;
